@if (showLoader) {
<por-app-loader></por-app-loader>
} @if (customer$ | async | count) {
<ng-container>
    <por-header [config]="config" [customer]="customer$ | async" (logout)="logoutUser()" (manageUsers)="viewContacts()"></por-header>
</ng-container>
<ng-container>
    <por-contracts [hidden]="appFacadeService.isManageUserDialogDisplayed() | async" [customer]="customer$ | async" [config]="config"></por-contracts>
</ng-container>
}
